/**
 * PSMS Routes
 * legacy app: canActivate: [AuthGuard]
 */

import React, { lazy } from 'react';
import { RouteConfig } from '../../types';
const PSMS_Main = lazy(() => import('@src/apps/PsmsMain/PSMS').then((m) => ({ default: m.PSMS })));
const PSMS = lazy(() => import('@src/apps/psms/PSMS').then((m) => ({ default: m.PSMS })));

const psmsRouteFrameStyles: React.CSSProperties = {
  width: '60rem',
  maxWidth: '100%',
  margin: '0 auto',
  boxSizing: 'border-box',
};

const PsmsRouteFrame: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div style={psmsRouteFrameStyles}>{children}</div>
);

const PSMSMainRoute = () => (
  <PsmsRouteFrame>
    <PSMS_Main />
  </PsmsRouteFrame>
);

const PSMSDetailRoute = () => (
  <PsmsRouteFrame>
    <PSMS />
  </PsmsRouteFrame>
);

export const psmsRoutes: RouteConfig[] = [
  {
    path: 'PSMS',
    component: PSMSMainRoute,
    guards: ['auth'],
    data: {
      title: 'PSMS',
      breadcrumb: 'PSMS',
      preload: false,
      delay: false,
    },
  },
  {
    path: 'PSMS/CallsAndChat',
    component: PSMSDetailRoute,
    guards: ['auth'],
    data: {
      title: 'PSMS - Calls and Chat',
      breadcrumb: 'Calls and Chat',
      preload: false,
      delay: false,
    },
  },
  {
    path: 'PSMS/PriorAuthorization',
    component: PSMSDetailRoute,
    guards: ['auth'],
    data: {
      title: 'PSMS - Prior Authorization',
      breadcrumb: 'Prior Authorization',
      preload: false,
      delay: false,
    },
  },
  {
    path: 'PSMS/Claims',
    component: PSMSDetailRoute,
    guards: ['auth'],
    data: { title: 'PSMS - Claims', breadcrumb: 'Claims', preload: false, delay: false },
  },
  {
    path: 'PSMS/PaymentIntegrity',
    component: PSMSDetailRoute,
    guards: ['auth'],
    data: {
      title: 'PSMS - Payment Integrity',
      breadcrumb: 'Payment Integrity',
      preload: false,
      delay: false,
    },
  },
  {
    path: 'PSMS/ViewTaxIdDetails',
    component: PSMSDetailRoute,
    guards: ['auth'],
    data: {
      title: 'PSMS - View Tax Id Details',
      breadcrumb: 'View Tax Id Details',
      preload: false,
      delay: false,
    },
  },
  {
    path: 'PSMS/AccountReceivable',
    component: PSMSDetailRoute,
    guards: ['auth'],
    data: {
      title: 'PSMS - Account Receivable',
      breadcrumb: 'Account Receivable',
      preload: false,
      delay: false,
    },
  },
  {
    path: 'PSMS/pype-entity',
    component: PSMSDetailRoute,
    guards: ['auth'],
    data: { title: 'PSMS - AI Genie', breadcrumb: 'AI Genie', preload: false, delay: false },
  },
];
